import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { sortBy } from 'lodash/fp';
import { HeadCell, TableCell, TableHeadSearchField, TableHeadSelect, Typography } from '../../../../ui-kit';
import { Options } from '../../../../components/forms/fields/types';
import { InventoryCountDetailsRow } from './utils';

interface InventoryCountTableHeadCellProps {
    index: number;
    headCell: HeadCell<InventoryCountDetailsRow>;
    stockCardCategoryId: string | null;
    setStockCardCategoryId(val: string | null): void;
    warehouseCategories: Options[];
    stockCardNameOrSku: string;
    setStockCardNameOrSku(val: string): void;
}

const InventoryCountTableHeadCell = ({
    index,
    headCell,
    stockCardCategoryId, setStockCardCategoryId, warehouseCategories,
    stockCardNameOrSku, setStockCardNameOrSku,
}: InventoryCountTableHeadCellProps) => {
    const { t } = useTranslation();
    let tableHeadCellContent: React.ReactNode;

    switch (headCell.id) {
        case 'categoryName': {
            const sortedOptions = sortBy(
                [({ name }) => name.toLowerCase(), 'asc'],
                warehouseCategories,
            );

            tableHeadCellContent = (
                <TableHeadSelect
                    fullWidth
                    label={t(...headCell.label)}
                    value={stockCardCategoryId}
                    onChange={setStockCardCategoryId}
                    options={sortedOptions}
                />
            );
            break;
        }
        case 'name':
            tableHeadCellContent = (
                <TableHeadSearchField
                    margin='dense'
                    value={stockCardNameOrSku}
                    onChange={setStockCardNameOrSku}
                    placeholder={t(...headCell.label)}
                    fullWidth
                />
            );
            break;
        default:
            tableHeadCellContent = <Typography uppercase color='textSecondary' variant='caption'>{t(...headCell.label)}</Typography>;
            break;
    }

    const isSticky = index === 0;
    return (
        <TableCell
            id={headCell.id as string}
            key={headCell.id as string}
            align={headCell.align}
            isTableHead
            isSticky={isSticky}
            padding='none'
        >
            <Box px={2}>
                {tableHeadCellContent}
            </Box>
        </TableCell>
    );
};

export default InventoryCountTableHeadCell;
